let arr = ['home', 'category', 'profile', 'evaluation', 'search']
export default { value: arr.join() }
